<template>
  <div class="col-12 my-3">
    <div class="row justify-content-between ">

      <m-a v-if="nextLesson != null" :href="{name:'SingleLesson',params:{courseSlug:this.courseLink,slug:this.nextLesson}}" target="_blank">
        <button class="btn px-5 btn-primary">درس بعدی</button>
      </m-a>

      <m-a v-if="pervLesson != null" :href="{name:'SingleLesson',params:{courseSlug:this.courseLink,slug:this.pervLesson}}" target="_blank">
        <button class="btn px-5 btn-danger">درس قبلی</button>
      </m-a>

    </div>
  </div>
</template>

<script>
import mA from "../../Tags/A.vue";

export default {
  name: "NextPervLesson",
  components: {mA},
  data() {
    return {
      nextLesson: null,
      pervLesson: null,
    }
  },
  props: {
    courseLink: {
      default: null
    },
    lessonLink: {
      default: null
    },
  },
  mounted() {

    let form = {
      courseSlug: this.courseLink,
      lessonSlug: this.lessonLink,
    }

    let req = this.$store.dispatch('Course/getLessonNextPerv', form)
    req.then(res => {
      let baseData = res.data.data;

      this.nextLesson = baseData.next
      this.pervLesson = baseData.perv

    })


  }
}
</script>

<style scoped>

</style>